unit RemittanceList.DTO;

interface

uses
  System.SysUtils,
  System.Classes,
  Generics.Collections;

type
  /// <summary>
  /// DTO for remittance list display - contains only the fields needed for the list view
  /// Following Orixa pattern of custom DTOs instead of entity sets
  /// </summary>
  TRemittanceListDTO = class
  public
    Id: Integer;
    InvoiceId: Integer;
    SchoolId: Integer;
    RemittanceDate: TDateTime;
    PaymentState: string;
    PaymentRef: string;
    PaymentMethod: string;
    PaymentKind: string;
    Amount: Currency;
    
    // Computed fields for display
    InvoiceRef: string;
    
    constructor Create;
  end;

  /// <summary>
  /// Response wrapper with pagination metadata for remittance list
  /// </summary>
  TRemittanceListResponse = class
  private
    FItems: TObjectList<TRemittanceListDTO>;
    FTotalCount: Integer;
    FPageSize: Integer;
    FCurrentPage: Integer;
    FTotalPages: Integer;
  public
    constructor Create;
    destructor Destroy; override;
    
    property Items: TObjectList<TRemittanceListDTO> read FItems write FItems;
    property TotalCount: Integer read FTotalCount write FTotalCount;
    property PageSize: Integer read FPageSize write FPageSize;
    property CurrentPage: Integer read FCurrentPage write FCurrentPage;
    property TotalPages: Integer read FTotalPages write FTotalPages;
  end;

implementation

{ TRemittanceListDTO }

constructor TRemittanceListDTO.Create;
begin
  inherited Create;
  Id := 0;
  InvoiceId := 0;
  SchoolId := 0;
  RemittanceDate := 0;
  PaymentState := '';
  PaymentRef := '';
  PaymentMethod := '';
  PaymentKind := '';
  Amount := 0;
  InvoiceRef := '';
end;

{ TRemittanceListResponse }

constructor TRemittanceListResponse.Create;
begin
  inherited Create;
  FItems := TObjectList<TRemittanceListDTO>.Create(True);
  FTotalCount := 0;
  FPageSize := 25;
  FCurrentPage := 1;
  FTotalPages := 0;
end;

destructor TRemittanceListResponse.Destroy;
begin
  FItems.Free;
  inherited Destroy;
end;

end.

